<template lang="pug">
  .sp-company-list-box(:class="{ 'sp-company-list-is-active': companyList }", v-if="!streetviewMode && spMode")
    .list-info-area
      .company-count
        p
          | {{ Number(companies.length).toLocaleString() }}件
          | ヒット
      .list-open
        a(@click="openCompanyList")
          span(v-if="companyButtonSp") 閉じる
          span(v-else) リスト表示
    .company-list
      ul.company-info-area(v-for="(company, index) in companies")
        li
          .company-name
            router-link(:to="{name: 'CompanyDetail', query: { id: company.id, from: 'map' }}" target="_blank") {{ company.company_name }}
            .col.marking(@click="toggle(company)", :class="{ 'on': company.in_job_mark }", :id='`markButtonList${company.company_id}`')
              span マーキング
          .company-tel
            a(v-if="company.company_tel"
              :href="company.company_tel"
              target="_blank"
              rel="noopener noreferrer"
            ) {{ company.company_tel }}
            span(v-else) -
          .company-url
            a(v-if="company.company_url"
              :href="company.company_url"
              target="_blank"
              rel="noopener noreferrer"
            ) {{ company.company_url }}
            span(v-else) -
          .company-place(@click="spMouseoverCompanyList(company.company_id)")
            span(v-if="company.company_place") {{ company.company_place }}
            span(v-else) -
          .company-budget(@click="spMouseoverCompanyList(company.company_id)")
            span 出稿予算
            ul
              li 今月：{{ company.budget_current_month }}
              li 先月：{{ company.budget_last_month }}
              li 3ヶ月：{{ company.budget_last_quarter }}
              li 6ヶ月：{{ company.budget_last_harf_year }}
              li 1年：{{ company.budget_last_year }}
            ul
          .company-published-media
            span 掲載：
            a(v-if="company.published_media_name_all"
              :href="company.master_url"
              target="_blank"
              rel="noopener noreferrer"
            ) {{ company.published_media_name_all }}
            span(v-else) -
</template>

<script>
  export default {
    props: ['companies', 'companyList', 'companyButtonSp', 'spMode', 'streetviewMode'],
    methods: {
      openCompanyList () {
        this.$emit('openCompanyList')
      },
      toggle (company) {
        this.$emit('toggle', company)
      },
      spMouseoverCompanyList (companyId) {
        this.$emit('spMouseoverCompanyList', companyId)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/MapSpCompanyList.vue